import React, { Component } from 'react';
import { UI } from 'common';

const { WrappedTriStateCheckbox } = UI;

export default class NameCellRenderer extends Component {
	constructor(props) {
		super(props);

		const { checkState, node } = props;

		this.state = {
			checkState,
		};

		if (checkState !== 0) {
			node.setSelected(true);
		}
	}

	onChange = e => {
		const { node, onSelectionChanged } = this.props;

		this.setState(
			{
				checkState: e.value,
			},
			() => {
				if (onSelectionChanged) {
					onSelectionChanged({
						...node.data,
						checkState: e.value,
					});
				}
			}
		);
	};

	render() {
		const { checkState } = this.state;
		const { name } = this.props;

		return (
			<div className="contacts-name-cell-renderer">
				<WrappedTriStateCheckbox
					value={checkState}
					onChange={this.onChange}
					dataqa="groups"
				/>
				<div className="checkbox-name">{name}</div>
			</div>
		);
	}
}
